<app-view-title Title="{{ 'Intellitrailer.Booking.LocationList.TitleLocation' | translate : 'Locations' }}" [isSplitColor]="true"></app-view-title>
<view-content>
  <app-search (valueChange)="filterLocations($event)"></app-search>
  @if(filteredLocations)
  {
  <div *ngFor="let loc of filteredLocations">
    <div class="row m-3" (click)="selectLocation(loc)">
      <div class="col-2">
      </div>
      <div class="col-8">
        <h2 class="m-0">{{ loc.Name }}</h2>
        <small>{{loc.Address}}</small>
      </div>
      @if(loc.Distance){
      <small class="col-2">{{ loc.Distance | number : '0.1-1' }}km</small>
      }
    </div>
  </div>
  }
</view-content>
<view-actions>
  <button type="button" color="accent" mat-raised-button class="mw-115" (click)="showMap()">{{ 'Intellitrailer.Booking.LocationList.btnMap' | translate : 'Show Map' }}</button>
</view-actions>
